// routes
import { PATH_AUTH, PATH_DASHBOARD, PATH_PAGE } from '../../routes/paths';
// components
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const ICON_SIZE = {
  width: 22,
  height: 22,
};

const menuConfig = [
  {
    title: 'Home',
    icon: <Iconify icon={'system-uicons:home'} {...ICON_SIZE} />,
    path: PATH_PAGE.root,
  },
  {
    title: 'Blog',
    icon: <Iconify icon={'ph:newspaper-light'} {...ICON_SIZE} />,
    path: PATH_PAGE.blog.root,
  },
  {
    title: 'Herramientas',
    path: PATH_PAGE.tools.root,
    icon: <Iconify icon={'fluent:square-hint-apps-20-regular'} {...ICON_SIZE} />,
    children: [
      {
        subheader: 'Lista',
        items: [
          { title: 'Tarot', path: PATH_PAGE.tools.tarot },
          { title: 'Flores de Bach', path: PATH_PAGE.tools.bachflowers },
          { title: 'Chakras', path: PATH_PAGE.tools.chakras },
          { title: 'Numerología', path: PATH_PAGE.tools.numerology },
          { title: 'Astrología', path: PATH_PAGE.tools.astralchart },
          { title: 'Cristaloterapia', path: PATH_PAGE.tools.crystals },
          { title: 'Oráculo de Sueños', path: PATH_PAGE.tools.suenos },
          { title: 'Runas Nórdicas', path: PATH_PAGE.tools.runas },
          { title: 'Nahual Mexica', path: PATH_PAGE.tools.nahual },
          { title: 'Quiromancia', path: PATH_PAGE.tools.quiromancia },
          { title: 'Biopares', path: PATH_PAGE.tools.biopairs },
        ],
      },
    ],
  },
  {
    title: 'Biblioteca',
    path: PATH_PAGE.biblioteca.root,
    icon: <Iconify icon={'ph:book-open-light'} {...ICON_SIZE} />,
    children: [
      {
        subheader: 'Catálogos',
        items: [
          { title: 'Flores de Bach', path: PATH_PAGE.biblioteca.bachflowers },
          { title: 'Chakras', path: PATH_PAGE.biblioteca.chakras },
          { title: 'Numerología', path: PATH_PAGE.biblioteca.numerology },
          { title: 'Planetas', path: PATH_PAGE.biblioteca.planets },
          { title: 'Cristales', path: PATH_PAGE.biblioteca.crystals },
          { title: 'Nahuales mexicas', path: PATH_PAGE.biblioteca.nahual },
          { title: 'Vidas pasadas', path: PATH_PAGE.biblioteca.pastLives },
        ],
      },
    ],
  },
  {
    title: 'Tienda',
    icon: <Iconify icon={'mdi:shopping-outline'} {...ICON_SIZE} />,
    path: PATH_PAGE.store.root,
  },
  {
    title: 'Acceder',
    icon: <Iconify icon={'system-uicons:door-alt'} {...ICON_SIZE} />,
    path: PATH_DASHBOARD.root,
  },
  {
    title: 'Registrate',
    icon: <Iconify icon={'system-uicons:door-alt'} {...ICON_SIZE} />,
    path: PATH_AUTH.register,
  },
];

const menuPrerelease = [
  {
    title: 'Home',
    icon: <Iconify icon='system-uicons:home' {...ICON_SIZE} />,
    path: '/prerelease',
  },
  {
    title: '¿Qué es Holistiqum?',
    path: '#section1',
    icon: <Iconify icon='fluent:info-20-regular' {...ICON_SIZE} />,
  },
  {
    title: 'Herramientas',
    path: '#section2',
    icon: <Iconify icon='system-uicons:cube' {...ICON_SIZE} />,
  },
  {
    title: 'Registrarse',
    path: '#register',
    icon: <Iconify icon='solar:user-rounded-linear' {...ICON_SIZE} />,
  },
  {
    title: 'Ingresar',
    path: PATH_AUTH.login,
    icon: <Iconify icon='system-uicons:door-alt' {...ICON_SIZE} />,
  },
];

export { menuConfig, menuPrerelease };
